/**
 * En dessous, un réel est du bruit de calcul : `toPrecision` garde sinon ses
 * chiffres (2.86e-13 ≠ 0), et un plan relu paraîtrait modifié.
 */
const NEAR_ZERO = 1e-9;

/** Arrondi stable des réels d'une empreinte (bruit flottant sans effet sur la comparaison). */
export const fingerprintNumber = (v: number): string =>
  Math.abs(v) < NEAR_ZERO ? "0" : String(Number(v.toPrecision(12)));

const TEXT_LEFT = 0;
const TEXT_BASELINE = 0;
const TEXT_ALIGNED = 3;
const TEXT_FIT = 5;

/**
 * Point(s) qui placent vraiment un texte. Justifié, sa position est déduite du point
 * d'alignement et de la police, et ODA la recalcule à la copie : l'empreinte n'en
 * dépend pas. À gauche, c'est l'alignement qui n'a pas de sens. « Aligné » et
 * « ajusté » s'appuient sur les deux.
 */
export function textAnchors(
  horizontalMode: number,
  verticalMode: number,
  position: string,
  alignment: string,
): string[] {
  if (horizontalMode === TEXT_LEFT && verticalMode === TEXT_BASELINE) {
    return [position];
  }
  if (horizontalMode === TEXT_ALIGNED || horizontalMode === TEXT_FIT) {
    return [position, alignment];
  }
  return [alignment];
}
